import { Box, Button } from '@mui/material'
import React from 'react'
import theme from '../../../theme'
import classrankedImage from '../../../assets/classrankedLogo_Mob.svg'
import { blue, grey } from '../../../colors'
import GenericButton from '../../../components/GenericButton'
import { ButtonSize, ButtonType } from '../../../components/GenericButton/styles'

interface GettingStartedPageProps {
  setCurrPage: (page: number) => void
}

export const GettingStartedPage: React.FC<GettingStartedPageProps> = ({ setCurrPage }): JSX.Element => {
  return (
    <Box
      flexGrow='1'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
    >
      <Box
        sx={{
          fontStyle: theme.typography.fontFamily,
          fontSize: theme.spacing(6),
          fontWeight: 'bold'
        }}
      >
        Welcome to Your Project Setup!
      </Box>
      <Box
        sx={{
          fontStyle: theme.typography.fontFamily,
          fontSize: theme.spacing(4)
        }}
      >
        Create your academic term and survey project in just a few steps.
      </Box>
      <Box>
        <b>Note:</b> logging out of your account will reset the setup wizard.
      </Box>
      <img
        src={classrankedImage}
        width={theme.spacing(900)}
        height={theme.spacing(900)}
        alt="Classranked Logo"
        style={{ margin: theme.spacing(16) }}
      />
      <GenericButton
        variant='contained'
        buttonSize={ButtonSize.Large}
        label='Get Started'
        onClick={() => { setCurrPage(1) }}
        buttonType={ButtonType.Primary}
      />
    </Box>
  )
}
